<script>
  import { blocklist, text, richtext, image, url } from "../toolbox.js";
  import { link, links } from "svelte-routing";

  export let block;
</script>

<section id="counts" class="counts">
  <div class="container" data-aos="fade-up">

    <div class="row gy-4">

      {#each blocklist(block, 'items') as item}
      <div class="col-lg-3 col-md-6">
        <div class="count-box">
          <img src="{image(item, 'icon', [null, 50])}"  height="50" alt="">
          <!-- <i class="bi bi-emoji-smile"></i> -->
          <div class="px-3">
            <!-- <span data-purecounter-start="0" data-purecounter-end="232" data-purecounter-duration="1" class="purecounter">29</span> -->
            <p>{text(item, 'title')}</p>
          </div>
        </div>
      </div>
      {/each}

    </div>

  </div>
</section>
